module.exports = __webpack_public_path__ + "static/media/email-offer-image.20bbd531.png";